import React, { useContext } from 'react';
import styled from 'styled-components';

import { Button, Icon } from 'components';
import TourEditContext from '../TourEditContext';
import { TourItemContent } from '../types';

export interface TourAcceptDenyShowingProps {
  item: TourItemContent;
}

const TourAcceptDenyShowing: React.FC<TourAcceptDenyShowingProps> = ({
  item: { status, listingContactTimeChange, appointmentId },
}) => {
  const { acceptSuggestedTime, denySuggestedTime } =
    useContext(TourEditContext);
  const [isLoading, setIsLoading] = React.useState(false);
  return (
    <>
      {status === 'time_change' && listingContactTimeChange && (
        <div>
          <StyledButton
            size="small"
            icon={
              <Icon
                type="antdCheckOutlined"
                width={12}
                offset={[0, -2]}
                color="gray8"
              />
            }
            onClick={async () => {
              setIsLoading(true);
              await acceptSuggestedTime(appointmentId);
              setIsLoading(false);
            }}
            loading={isLoading}
          >
            Accept
          </StyledButton>
          <StyledButton
            size="small"
            icon={
              <Icon
                type="antdCloseOutlined"
                width={12}
                offset={[0, -2]}
                color="gray8"
              />
            }
            onClick={async () => {
              setIsLoading(true);
              await denySuggestedTime(appointmentId);
              setIsLoading(false);
            }}
            loading={isLoading}
          >
            Deny
          </StyledButton>
        </div>
      )}
    </>
  );
};

export default TourAcceptDenyShowing;

const StyledButton = styled(Button)`
  border-radius: 4px;
  margin: 10px 10px 10px 0;
  margin-right: 10px;
  margin-top: 10px;
  font-weight: 400;
`;
